export function useMergedRef(...refs) {
    return (node) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(node);
            }
            else if (ref && 'current' in ref) {
                ref.current = node;
            }
        });
    };
}
//# sourceMappingURL=useMergedRef.js.map